import * as enums from '@playbook-technologies/common-enums';
import {
  LandingPageThemeId,
  landingPageThemes,
} from '@client/new/common/landingPageThemes';

export const isVisibleOptions = [
  {
    value: 'No',
    label: 'No',
  },
  {
    value: 'Yes',
    label: 'Yes',
  },
];

export const modeOptions = [
  {
    value: enums.Influencer.Mode.Onboarding.value,
    label: 'Onboarding',
  },
  {
    value: enums.Influencer.Mode.Live.value,
    label: 'Live',
  },
  {
    value: enums.Influencer.Mode.RunOff.value,
    label: 'Run off',
  },
  {
    value: enums.Influencer.Mode.Deactivated.value,
    label: 'Deactivated',
  },
];

export const tierOptions = [
  {
    value: enums.Influencer.Tier.First.value,
    label: enums.Influencer.Tier.First.name,
  },
  {
    value: enums.Influencer.Tier.Second.value,
    label: enums.Influencer.Tier.Second.name,
  },
  {
    value: enums.Influencer.Tier.Thrid.value,
    label: enums.Influencer.Tier.Thrid.name,
  },
  {
    value: enums.Influencer.Tier.Fourth.value,
    label: enums.Influencer.Tier.Fourth.name,
  },
  {
    value: enums.Influencer.Tier.Fifth.value,
    label: enums.Influencer.Tier.Fifth.name,
  },
  {
    value: enums.Influencer.Tier.Sixth.value,
    label: enums.Influencer.Tier.Sixth.name,
  },
];

export const paymentMethodOptions = [
  {
    value: enums.Influencer.PaymentMethod.StripeConnect.value,
    label: 'Stripe Connect',
  },
  {
    value: enums.Influencer.PaymentMethod.PayPal.value,
    label: 'PayPal',
  },
  {
    value: enums.Influencer.PaymentMethod.WireTransfer.value,
    label: 'Wire transfer',
  },
];

export const landingPageVisualVersionOptions = [
  { value: 1, label: '1 (current)' },
  { value: 2, label: '2 (new design)' },
] as const;

export type LandingPageVisualVersion =
  (typeof landingPageVisualVersionOptions)[number]['value'];

export const landingPageThemeOptions: ReadonlyArray<{
  value: LandingPageThemeId | null;
  label: string;
}> = [
  { value: null, label: 'Default (Clean studio)' },
  ...landingPageThemes.map(({ id, name }) => ({ value: id, label: name })),
];
